var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationBlackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3477 4.81535L12.3476 4.81511C11.6965 1.83839 9.18538 0.5 7.00282 0.5H6.99718C4.82158 0.5 2.30375 1.8314 1.65238 4.80925L1.65233 4.80949C0.936274 8.09071 2.87768 10.8173 4.51926 12.4575C5.18214 13.1239 6.07231 13.4999 7.00276 13.5H7.00282C7.8997 13.5 8.79407 13.1501 9.48102 12.4572C11.1222 10.8173 13.0637 8.09662 12.3477 4.81535ZM7.00282 7.35463C6.83814 7.35463 6.6746 7.32096 6.52135 7.255C6.36805 7.18903 6.22748 7.09178 6.1082 6.96784C5.98888 6.84387 5.89326 6.69566 5.8277 6.5312C5.76213 6.36673 5.72816 6.18982 5.72816 6.01073C5.72816 5.83165 5.76213 5.65474 5.82771 5.49026C5.89326 5.32581 5.98888 5.1776 6.1082 5.05362C6.22748 4.92968 6.36805 4.83244 6.52135 4.76646C6.6746 4.7005 6.83814 4.66683 7.00282 4.66683C7.33457 4.66683 7.65678 4.80358 7.89743 5.05362C8.13871 5.30431 8.27747 5.64826 8.27747 6.01073C8.27747 6.3732 8.13871 6.71715 7.89743 6.96784C7.65678 7.21788 7.33457 7.35463 7.00282 7.35463Z",
    stroke: "#221C35"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationBlackIcon);
export default __webpack_public_path__ + "static/media/location_black_icon.1d1dfc627dd7236d1fa3f8904ad6c379.svg";
export { ForwardRef as ReactComponent };